export default __webpack_public_path__ + "static/media/hht1_ep15_minisitcom_02.e5c22979.png";